export enum StudySituations {
    UNKNOWN,
    NOT_PRESENT_LOCALLY,
    PARTIALLY_PRESENT_LOCALLY,
    ALREADY_PRESENT_LOCALLY
}